import React, { useState, useEffect } from 'react';
import './IOSInstallGuide.css';

const IOSInstallGuide = () => {
  const [showGuide, setShowGuide] = useState(false);

  useEffect(() => {
    // Detecta se é iOS e se não está em modo standalone (já instalado)
    const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
    const isStandalone = window.matchMedia('(display-mode: standalone)').matches || 
                         window.navigator.standalone || 
                         document.referrer.includes('android-app://');
    
    // Verifica se o guia já foi mostrado nesta sessão
    const guideShown = localStorage.getItem('iosInstallGuideShown');
    
    // Só mostra o guia se for iOS, não estiver instalado e não tiver sido mostrado
    if (isIOS && !isStandalone && !guideShown) {
      setShowGuide(true);
    }
  }, []);

  const closeGuide = () => {
    setShowGuide(false);
    // Salva no localStorage para não mostrar novamente na mesma sessão
    localStorage.setItem('iosInstallGuideShown', 'true');
  };

  if (!showGuide) return null;

  return (
    <div className="ios-install-guide">
      <div className="ios-install-guide-content">
        <button className="ios-install-guide-close" onClick={closeGuide}>×</button>
        <h3>Instale o App no seu iPhone</h3>
        <div className="ios-install-steps">
          <div className="ios-install-step">
            <div className="ios-install-step-number">1</div>
            <p>Toque no botão <span className="ios-share-icon">↑</span> na barra de navegação</p>
          </div>
          <div className="ios-install-step">
            <div className="ios-install-step-number">2</div>
            <p>Role para baixo e toque em <strong>"Adicionar à Tela de Início"</strong></p>
          </div>
          <div className="ios-install-step">
            <div className="ios-install-step-number">3</div>
            <p>Toque em <strong>"Adicionar"</strong> no canto superior direito</p>
          </div>
        </div>
        <div className="ios-install-note">
          <p>Após a instalação, você terá acesso rápido ao app diretamente da sua tela inicial.</p>
        </div>
      </div>
    </div>
  );
};

export default IOSInstallGuide;
